<template>
        <div class="block-content">
          <ul class="list list-activity">
            <li v-if="order.return_shipment">
              <i class="si si-action-undo text-danger"></i>
              <div class="font-w600">Retourzending aangemaakt</div>
              <div>
                <a :href="order.return_shipment.track_and_trace_url" target="_blank">
                  <i class="fa fa-external-link"></i>
                  {{order.return_shipment.barcode}}
                </a>
              </div>
              <div class="font-size-xs text-muted">{{order.return_shipment.created_at | moment('calendar') | capitalize}}</div>
            </li>
            <li v-if="order.status === 'completed'">
              <i class="si si-check text-success"></i>
              <div class="font-w600">Bestelling afgerond</div>
              <div class="font-size-xs text-muted">{{completedAt | moment('calendar') | capitalize}}</div>
              <div v-if="order.weshipp_id">
                <button v-if="!solTrackAndTraceUrl" type="submit" class="btn btn-alt-primary" @click="getSolTrackAndTraceUrl">
                  <i class="fa fa-external-link"> SOL Track & trace ophalen </i>
                  <i v-if="loading" class="fa fa-spin fa-8x fa-spinner"></i>
                </button>
                <a v-else :href="solTrackAndTraceUrl" target="_blank">
                  <i class="fa fa-external-link"></i>
                  SOL Track & trace
                </a>
              </div>
            </li>
            <li v-if="order.shipment">
              <i class="si si-paper-plane text-warning"></i>
              <div class="font-w600">Verzending aangemaakt</div>
              <div>
                <a href="#" @click.prevent="printLabel"><i class="fa fa-print"></i></a>
                <a :href="order.shipment.track_and_trace_url" target="_blank">
                  <i class="fa fa-external-link"></i>
                  {{order.shipment.barcode}}
                </a>
              </div>
              <div class="font-size-xs text-muted">{{order.shipment.created_at | moment('calendar') | capitalize}}</div>
            </li>
            <li v-if="pickedAt">
              <i class="si si-directions text-info"></i>
              <div class="font-w600">Producten gepickt</div>
              <div class="font-size-xs text-muted">{{pickedAt | moment('calendar') | capitalize}}</div>
            </li>
            <li>
              <i class="si si-basket text-danger"></i>
              <div class="font-w600">Bestelling geplaatst</div>
              <div class="font-size-xs text-muted">{{order.placed_at | moment('calendar') | capitalize}}</div>
            </li>
          </ul>
        </div>
</template>

<script>
import http from '../utils/http'

export default {
  props: {
    order: Object
  },
  data () {
    return {
      solTrackAndTraceUrl: null,
      loading: false
    }
  },
  computed: {
    pickedAt () {
      if (this.order.status === 'picked') {
        return this.order.updated_at
      }

      if (this.order.status === 'completed') {
        return this.completedAt
      }

      return null
    },
    completedAt () {
      if (this.order.status === 'completed') {
        return this.order.shipment ? this.order.shipment.created_at : this.order.updated_at
      }

      return null
    }
  },
  methods: {
    getSolTrackAndTraceUrl () {
      this.loading = true

      http.get(`/sol-order/${this.order.id}`)
        .then((result) => {
          this.solTrackAndTraceUrl = result.data.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$swal('Ehmm...', 'Er is iets misgegaan met het ophalen van de track en trace url voor deze bestelling. Probeer het opnieuw.', 'warning')
        })
    },
    printLabel () {
      this.$emit('print:label')
    }
  }
}

</script>

<style scoped>
a.disabled.block {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// OrderTimeline.vue?412d656a